import { render } from "./ImageUpload.vue?vue&type=template&id=66d37abb&scoped=true&ts=true"
import script from "./ImageUpload.vue?vue&type=script&lang=ts"
export * from "./ImageUpload.vue?vue&type=script&lang=ts"

import "./ImageUpload.vue?vue&type=style&index=0&id=66d37abb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d37abb"]])

export default __exports__